import { useSelector } from 'react-redux'
import { editorThunks } from 'store/features/editor/thunks'
import { editorSelectors } from 'store/features/editor/selectors'
import { SLICE_DURATION_VALUES } from './consts'
import * as Styled from './styled'
import ZoomInOut from './ZoomInOut'
import ActionButtons from './ActionButtons'
import PlayPauseButton from './PlayPauseButton'
import { dispatch } from 'store'

const Header: React.FC = () => {
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )
  const zoomValue = SLICE_DURATION_VALUES.indexOf(timelineRulerSliceDuration)

  return (
    <Styled.Header>
      <ActionButtons />
      <PlayPauseButton />
      <ZoomInOut
        zoomValue={zoomValue}
        minValue={0}
        maxValue={SLICE_DURATION_VALUES.length - 1}
        onChange={zoomValue => {
          dispatch(
            editorThunks.setTimelineRulerSliceDuration(
              SLICE_DURATION_VALUES[zoomValue]
            )
          )
        }}
        step={1}
      />
    </Styled.Header>
  )
}

export default Header
